import { OutagePageContent } from "./PageContent";

export function OutagePage() {
  return <OutagePageContent />;
}
